import React from 'react';
import { LenderFieldMap } from '@trnsact/trnsact-shared-types';
import { LenderFieldMapWithErrors } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/types';
import { SelectMappingField } from './SelectMappingField';
import { getInputProps } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/lib';
import { TextMappingField } from './TextMappingField';
import { formatInitials, formatPhoneInput, formatSSNInput, formatTaxID } from 'formatters';
import { DateMappingField } from './DateMappingField';

interface Props {
  field: LenderFieldMapWithErrors;
  onValueChange: (lenderProperty: string, newValue: any) => void;
}

export const MappingInput = ({ field, onValueChange }: Props) => {
  const type = field.details?.fieldInputType;
  const inputProps = getInputProps(field);

  switch (type) {
    case 'OPTION_SET':
    case 'YEAR':
    case 'MONTH':
    case 'DAY':
    case 'STATE':
    case 'STATE_ABBR':
    case 'COUNTRY_CODE':
    case 'COUNTRY':
      return <SelectMappingField field={field} inputProps={inputProps} onValueChange={onValueChange} />;
    case 'INITIALS':
      let initials = field.mappedValue || '';
      if (initials && initials.length > 2) initials = initials.match(/\b(\w)/g).join('');
      return (
        <TextMappingField
          field={{
            ...field,
            mappedValue: initials.toUpperCase(),
          }}
          formatter={formatInitials}
          inputProps={getInputProps(field)}
          onValueChange={onValueChange}
        />
      );
    case 'SSN':
      return (
        <TextMappingField
          field={field}
          formatter={formatSSNInput}
          inputProps={getInputProps(field)}
          onValueChange={onValueChange}
        />
      );
    case 'FEIN':
      return (
        <TextMappingField
          field={field}
          formatter={formatTaxID}
          inputProps={getInputProps(field)}
          onValueChange={onValueChange}
        />
      );
    case 'PHONE_NUMBER':
      return (
        <TextMappingField
          field={field}
          formatter={formatPhoneInput}
          inputProps={getInputProps(field)}
          onValueChange={onValueChange}
        />
      );
    case 'DATE':
      return <DateMappingField field={field} onValueChange={onValueChange} />;
    default:
      return <TextMappingField field={field} inputProps={getInputProps(field)} onValueChange={onValueChange} />;
  }
};
